type FlowArrowIconProps = {
  color?: string; // 아이콘 색상
  direction?: "left" | "right"; // 방향
  size?: number; // 크기
};

const FlowArrowIcon = ({
  color = "#FF5C5C",
  direction = "right",
  size = 14,
}: FlowArrowIconProps) => {
  const rotation = direction === "left" ? "rotate(180deg)" : "none";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: rotation }}
    >
      <path
        d="M1.00002 5.99999L10.5861 5.99999L6.29307 1.70697C5.90254 1.31645 5.90254 0.683424 6.29307 0.292896C6.68361 -0.0976324 7.31663 -0.0976323 7.70716 0.292896L13.7073 6.29296L13.7756 6.36913C14.096 6.76191 14.0734 7.34092 13.7073 7.70704L7.70716 13.7071C7.31663 14.0976 6.6836 14.0976 6.29307 13.7071C5.90254 13.3166 5.90254 12.6836 6.29307 12.293L10.5861 8.00001L1.00002 8.00001C0.447724 8.00001 6.27469e-07 7.55229 6.5161e-07 7C9.33459e-07 6.44771 0.447724 5.99999 1.00002 5.99999Z"
        fill={color}
      />
    </svg>
  );
};

export default FlowArrowIcon;
